export function printCertificate(params: { ime: string; priimek: string; oznaka_gume: number | string }) {
  const { ime, priimek, oznaka_gume } = params;

  const safeIme = String(ime || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const safePriimek = String(priimek || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const safeOznaka = String(oznaka_gume || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // Create hidden iframe to print without opening a new tab
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument || iframe.contentWindow?.document;
  if (!doc) {
    document.body.removeChild(iframe);
    return;
  }

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Potrdilo</title>
  <style>
    /* Enforce A4 landscape with no margins */
    @page { size: A4 landscape; margin: 0; }
    html, body { height: 100%; margin: 0; padding: 0; }
    body { font-family: Arial, Helvetica, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    /* Fixed A4 landscape page box */
    .page {
      width: 297mm; /* A4 landscape width */
      height: 210mm; /* A4 landscape height */
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .wrap { text-align: center; width: 100%; padding: 0 40px; box-sizing: border-box; }
    /* Increase sizes by ~25% (60 -> 75, 80 -> 100) */
    .name { font-size: 75px; font-weight: 700; }
    .oznaka { font-size: 100px; font-weight: 800; margin-top: 24px; }
  </style>
</head>
<body>
  <div class="page">
    <div class="wrap">
      <div class="name">${safeIme} ${safePriimek}</div>
      <div class="oznaka">${safeOznaka}</div>
    </div>
  </div>
  <script>
    (function(){
      function doPrint(){
        try { window.focus(); } catch(e) {}
        setTimeout(function(){ window.print(); }, 50);
      }
      if (document.readyState === 'complete') doPrint();
      else window.onload = doPrint;
    })();
  </script>
</body>
</html>`;

  doc.open();
  doc.write(html);
  doc.close();

  const win = iframe.contentWindow;
  if (win) {
    const cleanup = () => {
      // Delay cleanup slightly to avoid interfering with print dialog
      setTimeout(() => {
        try { document.body.removeChild(iframe); } catch (e) {}
      }, 300);
    };
    // Attempt cleanup after print
    win.addEventListener('afterprint', cleanup);
    // Fallback cleanup in case afterprint doesn't fire
    setTimeout(cleanup, 3000);
  }
}
